import { render } from "./WarehousePanel.vue?vue&type=template&id=3368eca0&scoped=true"
import script from "./WarehousePanel.vue?vue&type=script&lang=js"
export * from "./WarehousePanel.vue?vue&type=script&lang=js"

import "./WarehousePanel.vue?vue&type=style&index=0&id=3368eca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3368eca0"]])

export default __exports__